<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-icon small class="mr-2" v-on="on" >mdi-pencil</v-icon>
      </template>
      <v-card>
       <v-form @submit.prevent="finalizarRevision(abono, revision)">
           <v-tabs
            v-model="tab"
            background-color="primary"
            dark
            >
            
            <v-tab :href="'#'+tab">Revision 1*</v-tab>
            <v-tab :href="'#'+tab">Revision 2*</v-tab>
            <v-tab :href="'#'+tab">Revision 3</v-tab>
            <v-tab :href="'#'+tab">Revision 4*</v-tab>
            <v-tab :href="'#'+tab">Revision 5*</v-tab>
            </v-tabs>
    
            <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
                <v-card flat>
                <v-card-text>
                <v-alert
                    border="right"
                    colored-border
                    type="info"
                    elevation="2"
                >
                    IMPRESCINDIBLE REVISAR SI SON ORDENADORES, EL SISTEMA OPERATIVO QUE NO HAYA SIDO USADO NI ACTIVADO Y QUE LA CONFIGURACIÓN COINCIDE CON LA FACTURADA
                </v-alert>
                <v-alert
                    border="right"
                    colored-border
                    type="error"
                    elevation="2"
                    v-if="!$v.revision.abierto.required"
                    >
                    Debes seleccionar una opción
                </v-alert>
                <v-subheader>¿El/Los articulos han sido abiertos?</v-subheader>
                <v-row class="d-flex justify-center">
                    <v-radio-group v-model="$v.revision.abierto.$model"  row>
                        <v-radio label="Si" value="Si" ></v-radio>
                        <v-radio label="No" value="No"></v-radio>
                        <v-radio label="No se sabe" value="No se sabe"></v-radio>
                    </v-radio-group>
                </v-row>
                </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-2">
                <v-card flat>
                <v-card-text>
                 <v-alert
                    border="right"
                    colored-border
                    type="error"
                    elevation="2"
                    v-if="!$v.revision.estado.required"
                    >
                    Debes seleccionar una opción
                </v-alert>
                <v-subheader>¿Está/Están en perfecto estado para la venta?</v-subheader>
                <v-row class="d-flex justify-center">
                    <v-radio-group v-model="$v.revision.estado.$model" row>
                        <v-radio label="Si" value="true"></v-radio>
                        <v-radio label="No" value="false"></v-radio>
                    </v-radio-group>
                </v-row>
                </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-3">
                <v-card flat>
                <v-card-text>
                 
                <v-subheader>Añade aquí las imagenes del estado del producto</v-subheader>
                 <v-file-input
                        v-model="revision.files"
                        placeholder="picha para seleccionar las imágenes"
                        label="Imágenes"
                        multiple
                        ref="filesImages"
                        prepend-icon="mdi-camera"
                    >
                        <template v-slot:selection="{ text }">
                        <v-chip
                            small
                            label
                            color="primary"
                        >
                            {{ text }}
                        </v-chip>
                        </template>
                    </v-file-input>
                </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-4" >
                <v-card flat>
                <v-card-text>
                <v-textarea v-model="revision.observaciones" label="Observaciones" hint="Observaciones de la Revisión"></v-textarea>
                </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item value="tab-5">
                <v-card flat>
                <v-card-text>
                 <v-alert
                    border="right"
                    colored-border
                    type="error"
                    elevation="2"
                    v-if="!$v.revision.tramitar.required"
                    >
                    Debes seleccionar una opción
                </v-alert>
                <v-subheader>Abono para tramitar</v-subheader>
                <v-row class="d-flex justify-center">
                    <v-radio-group v-model="$v.revision.tramitar.$model" row>
                        <v-radio label="Si" value="Tramitado"></v-radio>
                        <v-radio label="No" value="No tramitado"></v-radio>
                    </v-radio-group>
                </v-row>
                </v-card-text>
                </v-card>
            </v-tab-item>
            </v-tabs-items>
            <v-card-actions>
                <v-btn color="blue darken-1" text @click="minusTab()" :disabled="number == 1"><v-icon>mdi-arrow-left</v-icon></v-btn>
                <v-btn color="blue darken-1" text @click="plusTab()" :disabled="number == 5"><v-icon>mdi-arrow-right</v-icon></v-btn>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn>
              <v-btn color="blue darken-1" text type="submit" :disabled="$v.$invalid">Guardar</v-btn>
            </v-card-actions>
       </v-form>
      </v-card>
    </v-dialog>
</template>
<script>
import {mapActions} from 'vuex';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'Revision',
    data: () => ({
      dialog: false,
      revision: {
          abierto: '',
          estado: null,
          observaciones: '',
          tramitar: null,
          files: [],
      },
      number: 1
    
    }),
    validations: {
        revision: {
            abierto: {
                required
            },
            estado: {
                required
            },
            tramitar: {
                required
            },
        }
    },
    props: ['abono'],
    methods: {
        ...mapActions(['tramitarAbono', 'subirImagenes']),
        finalizarRevision(abono, revision){
            console.log('submit!')
            this.$v.$touch()
            if(this.$v.$invalid) {
                console.log('error validaciones');
            }else {
                this.subirImagenes([revision.files, abono.factura, abono.id])
                this.tramitarAbono([abono, revision])
                this.dialog = false;
            }
            
            
        },
        plusTab(){
            this.number++
        },
        minusTab(){
            this.number--
        }
    },
    computed: {
        tab: function () {
            return 'tab-' + this.number
        }
    },
}
</script>